export default {
  background_image: 'Baggrundsbillede',
};
